// TO-DO: need to migrate existing ModalConfirm to this NewModalConfirm component in the future
import { isArray } from '@helpers/Array';
import { isEmpty } from '@helpers/String';
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, useTheme } from '@mui/material';
import { ModalConfirmProps } from '@types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
	root: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		borderRadius: 16,
		padding: 24,
		width: 'max-content'
	},
	closeButton: {
		backgroundColor: 'white',
		color: 'black',
		minWidth: 160,
		width: '100%',
		height: 60
	},
	centerText: {
		textAlign: 'center',
		whiteSpace: 'break-spaces'
	},
	topSpacing: {
		padding: 0,
		width: '100%'
	},
	buttonTopSpacing: {
		marginTop: 16,
		gap: 8,
		padding: '16px 16px 0px 16px'
	},
	buttonColumnAlign: {
		display: 'flex',
		flexDirection: 'column',
		gap: '16px'
	},
	dialogActionsRoot: {
		width: '100%'
	},
	dialogContent: {
		padding: 0,
		width: '100%'
	}
}));

const ActionButtons = ({ handleClose, buttons, stayOpen }) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	const navigate = useNavigate();
	const theme = useTheme();

	const handleNavigation = (nextUrl: string) => {
		if (!isEmpty(nextUrl)) navigate(nextUrl);
	};

	if (!isArray(buttons)) {
		return (
			<Button onClick={handleClose} variant="contained" className={classes.closeButton}>
				{t('CLOSE')}
			</Button>
		);
	}

	return (
		<>
			{buttons &&
				buttons.map((button, index) => (
					<Button
						key={`button-${index}`}
						onClick={() => {
							typeof button?.func === 'function' && button?.func();
							handleNavigation(button?.nextUrl);
							!stayOpen && handleClose();
						}}
						startIcon={button?.isLoading && <CircularProgress size="20px" sx={{ color: theme.palette.secondary.light }} />}
						disabled={button?.isDisabled}
						variant={button?.variant ?? 'contained'}
						color={button?.color ?? 'secondary'}
						sx={{ minWidth: 160, width: '100%', height: 40, borderRadius: '365px', ...{ ...button?.styles } }}>
						{t(button?.label)}
					</Button>
				))}
		</>
	);
};

const NewModalConfirm = ({
	open,
	isLoading,
	handleClose,
	title,
	content,
	buttons,
	buttonAlign,
	stayOpen = false,
	customStyles
}: ModalConfirmProps) => {
	const { classes, cx } = useStyles();

	return (
		<Dialog
			open={open}
			classes={{
				paper: cx(classes.root, customStyles?.dialogRootClass)
			}}>
			<DialogTitle id="alert-dialog-title" component="div" classes={{ root: cx(classes.topSpacing, customStyles?.dialogTitleClass) }}>
				<>{title}</>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<DialogContentText component="div" id="alert-dialog-description" className={classes.centerText}>
					{content}
				</DialogContentText>
			</DialogContent>
			<DialogActions
				classes={{
					root: cx(classes.dialogActionsRoot, classes.buttonTopSpacing, customStyles?.buttonTopSpacing, {
						[classes.buttonColumnAlign]: buttonAlign === 'column'
					})
				}}
				disableSpacing={true}>
				{isLoading ? <CircularProgress color="secondary" /> : <ActionButtons buttons={buttons} handleClose={handleClose} stayOpen={stayOpen} />}
			</DialogActions>
		</Dialog>
	);
};

export default NewModalConfirm;
